const API_V1_PATH = '/api/v1'
const TRANSACTIONS_PATH = '/transactions'
const ANALYTICS_PATH = '/analytics'
const COMPLIANCE_PATH = '/compliance'
const AUTH_TOKEN_PATH = '/auth/token'

const getTrimmedEnv = (value) => (typeof value === 'string' ? value.trim() : '')

const normalizeBaseUrl = (rawBaseUrl) => {
  const baseUrl = getTrimmedEnv(rawBaseUrl)

  if (!baseUrl) {
    throw new Error('Missing required environment variable: REACT_APP_API_RULES_URL')
  }

  return baseUrl.replace(/\/+$/, '')
}

export const getRulesEngineApiBaseUrl = (rawBaseUrl) => {
  const normalizedUrl = normalizeBaseUrl(rawBaseUrl)
  const apiVersionIndex = normalizedUrl.indexOf(API_V1_PATH)

  if (apiVersionIndex === -1) {
    return `${normalizedUrl}${API_V1_PATH}`
  }

  return normalizedUrl.slice(0, apiVersionIndex + API_V1_PATH.length)
}

export const getRulesEngineTransactionsUrl = (rawBaseUrl) => (
  `${getRulesEngineApiBaseUrl(rawBaseUrl)}${TRANSACTIONS_PATH}`
)

export const getAccessManagementApiBaseUrl = (rawBaseUrl = process.env.REACT_APP_AUTHENTICATOR_API) => {
  const normalizedUrl = getTrimmedEnv(rawBaseUrl).replace(/\/+$/, '')

  if (!normalizedUrl) {
    throw new Error('Missing required environment variable: REACT_APP_AUTHENTICATOR_API')
  }

  return normalizedUrl
}

export const getAccessManagementAuthUrl = (rawBaseUrl = process.env.REACT_APP_AUTHENTICATOR_API) => (
  `${getAccessManagementApiBaseUrl(rawBaseUrl)}${AUTH_TOKEN_PATH}`
)

export const getAccessManagementUsersUrl = (subpath = '', rawBaseUrl) => {
  const trimmedSubpath = getTrimmedEnv(subpath).replace(/^\/+/, '')
  const base = `${getAccessManagementApiBaseUrl(rawBaseUrl)}/users`

  return trimmedSubpath ? `${base}/${trimmedSubpath}` : base
}

export const getAccessManagementOrganizationsUrl = (subpath = '', rawBaseUrl) => {
  const trimmedSubpath = getTrimmedEnv(subpath).replace(/^\/+/, '')
  const base = `${getAccessManagementApiBaseUrl(rawBaseUrl)}/organizations`

  return trimmedSubpath ? `${base}/${trimmedSubpath}` : base
}

export const getAccessManagementRolesUrl = (subpath = '', rawBaseUrl) => {
  const trimmedSubpath = getTrimmedEnv(subpath).replace(/^\/+/, '')
  const base = `${getAccessManagementApiBaseUrl(rawBaseUrl)}/roles`

  return trimmedSubpath ? `${base}/${trimmedSubpath}` : base
}

export const getAccessManagementPermissionsUrl = (subpath = '', rawBaseUrl) => {
  const trimmedSubpath = getTrimmedEnv(subpath).replace(/^\/+/, '')
  const base = `${getAccessManagementApiBaseUrl(rawBaseUrl)}/permissions`

  return trimmedSubpath ? `${base}/${trimmedSubpath}` : base
}

export const getRulesEngineAnalyticsUrl = (rawBaseUrl, endpoint) => {
  const normalizedEndpoint = getTrimmedEnv(endpoint).replace(/^\/+/, '')

  if (!normalizedEndpoint) {
    throw new Error('Analytics endpoint is required')
  }

  return `${getRulesEngineApiBaseUrl(rawBaseUrl)}${ANALYTICS_PATH}/${normalizedEndpoint}`
}

export const getRulesEngineOperationUrl = (rawBaseUrl, operationId) => {
  if (operationId === null || operationId === undefined || operationId === '') {
    throw new Error('Operation id is required')
  }

  const normalizedOperationId = getTrimmedEnv(String(operationId))

  if (!normalizedOperationId) {
    throw new Error('Operation id is required')
  }

  return `${getRulesEngineTransactionsUrl(rawBaseUrl)}/operation/${encodeURIComponent(normalizedOperationId)}`
}

export const getRulesEngineComplianceUrl = (rawBaseUrl, endpoint) => {
  const normalizedEndpoint = getTrimmedEnv(endpoint).replace(/^\/+/, '')

  if (!normalizedEndpoint) {
    throw new Error('Compliance endpoint is required')
  }

  return `${getRulesEngineApiBaseUrl(rawBaseUrl)}${COMPLIANCE_PATH}/${normalizedEndpoint}`
}

export const getRulesEngineTransactionAssistantUrl = (rawBaseUrl) => (
  getRulesEngineComplianceUrl(rawBaseUrl, 'transaction-assistant')
)
